import React from 'react';
import { Box, Icons, Typography, useTheme } from '@ublend-npm/aulaui-core';
import { Post } from '@app/types/core';
import { createStyles } from './CommonRoomResponsive.styles';
import CommonRoomPostCard from './CommonRoomPostCard.container';

interface CommonRoomFeedResponsiveProps {
  posts?: Post[];
}

const CommonRoomFeedResponsive = ({
  posts = [],
}: CommonRoomFeedResponsiveProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.feedLayout} data-testid="responsive-feed-layout">
      <Box
        component="section"
        aria-label="Post composer"
        sx={styles.composerRegion}
      >
        <Box sx={styles.placeholderHeader}>
          <Box sx={styles.placeholderIcon} aria-hidden="true">
            <Icons.EditOutlined fontSize="small" />
          </Box>
          <Box sx={styles.placeholderText}>
            <Typography component="h2" variant="subtitle1">
              Create a post
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Share something with your space…
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        component="section"
        aria-label="Feed controls"
        sx={styles.feedControlsRegion}
      >
        <Box sx={styles.feedTabs}>
          <Typography sx={styles.activeFeedTab}>Feed</Typography>
          <Typography color="text.secondary">Pinned</Typography>
        </Box>
        <Typography color="text.secondary">Filter</Typography>
      </Box>

      <Box
        component="section"
        aria-label="Common Room feed"
        sx={styles.postsRegion}
      >
        <Box sx={styles.postsList}>
          {posts?.map((post) => (
            <CommonRoomPostCard key={post.objectId} post={post} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CommonRoomFeedResponsive;
